module.exports = __webpack_public_path__ + "static/media/Time_management.92479173.jpeg";